import {CONFIG} from "../../config";
import axios from "axios";

async function DeleteGroupQuery(id) {
    const location = CONFIG.API_URL + "group/delete/" + id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.delete(location, settings);
    } catch (e) {
        return e;
    }
}

export default DeleteGroupQuery;